// extracted by mini-css-extract-plugin
export default {"container":"App_container__p8vTH","app":"App_app__8uVUF","selected":"App_selected__pnLRK","typewriter-text":"App_typewriter-text__A4mDy","typing":"App_typing__+u9oj"};